import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { formatDate, defaultField, defaultPercentField } from "helpers/row-logic-helper";

const DEFAULT_WIDTH = 138;

export const rows = {
  projectedExitDate: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Projected Exit Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE,
        map: data => formatDate(defaultField(data, "projectedExitDate"), "MMM D, YYYY"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  actualExitDate: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Actual Exit Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE,
        map: data => formatDate(defaultField(data, "actualExitDate"), "MMM D, YYYY"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  salesPrice: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Sales Price",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: data => defaultField(data, "salesPrice"),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  pricePerUnit: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Price Per Unit",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: data => defaultField(data, "pricePerUnit"),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  pricePerSquareFoot: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Price Per SF",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: data => defaultField(data, "pricePerSquareFoot"),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  exitCapRate: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Exit Cap Rate",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: data => defaultPercentField(data, "exitCapRate", 100),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  exitDebtYield: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Exit Debt Yield",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: data => defaultPercentField(data, "exitDebtYield", 100),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  cashOnCash: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Cash on Cash Returns",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: data => defaultPercentField(data, "cashOnCash", 100),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  internalRateOfReturn: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Internal Rate of Return",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: data => defaultPercentField(data, "internalRateOfReturn", 100),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  equityMultiple: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Equity Multiple",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "equityMultiple"),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  salesBrokerCompany: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Sales Broker Company",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "salesBrokerCompany.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  salesBrokerContact: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Sales Broker Contact",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "salesBrokerContact.fullName"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  notesOnBuyer: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Notes on Buyer",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "notesOnBuyer"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
